import {
  Box,
  Card,
  Dialog,
  DialogContent,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@material-ui/core";
import * as React from "react";
import { FC, useEffect, useState } from "react";
import {
  ListProps,
  ShowButton,
  useDataProvider,
  useNotify,
  EditButton,
  usePermissions,
} from "react-admin";
import DeleteForeverIcon from "@material-ui/icons/DeleteForever";
import { getFieldByTitle } from "../../helpers/sortByTitle";
import { Winner } from "../../types/winner";
import PaginationTable from "../common/paginationTable";
import HeadTable from "../common/sortTable/sortTable";
import TablesSearch from "../common/tablesSearch/tablesSearch";

import "./index.css";
import { getDateForPicker } from "../../helpers/dateHelper";
import DateFilter from "../users/DateFilter";
import SettingsListTittle from "../common/listTitles/WinnersListTitle";
import { checkPermission } from "../../helpers/checkPermissions";
import { RemoveEntityModalContent } from "../common/removeEntityPopUp/RemoveEntity";

const WinnersList: FC<ListProps> = (props) => {
  const { permissions } = usePermissions();
  const dataProvider = useDataProvider();
  const notify = useNotify();
  const [state, setState] = useState({
    winners: Array<Winner>(),
    total: 0,
    page: 1,
    perPage: 10,
    field: "_id",
    order: "asc",
  });

  const [dropdown, setDropdown] = useState({
    competitionNumber: false,
    competition: false,
    finish: false,
    title: false,
  });
  const [searchState, setSearchState] = useState({
    competitionNumber: "",
    competition: "",
    finishDate: "",
    title: "",
  });
  const [filter, setFilter] = useState({
    blocked: "all",
    searchField: "",
    startDate: new Date("2000-01-18T19:55:00.000+00:00"),
    endDate: new Date("2030-01-18T19:55:00.000+00:00"),
  });

  const [blockedFilter, setBlockedFilter] = useState({
    with: false,
    without: false,
  });

  const [modal, setModal] = useState({
    showModal: false,
    id: "",
  });

  useEffect(() => {
    getWinners(
      "all",
      1,
      10,
      "_id",
      "asc",
      filter.endDate,
      filter.startDate,
      "",
      "",
    );
  }, []);

  const getWinners = async (
    blocked: string,
    page: number,
    perPage: number,
    field: string,
    order: string,
    endDate: Date,
    startDate: Date,
    searchString: string | Array<string>,
    searchField: string,
  ) => {
    const winners = (await dataProvider.getList("winners", {
      filter: {
        blocked: blocked,
        searchString: searchString,
        searchField: searchField,
        startDate,
        endDate,
      },
      pagination: { page: page, perPage: perPage },
      sort: { field: field, order: order },
    })) as any;
    setState({
      ...state,
      winners: winners.data,
      total: winners.total,
      page: page,
      perPage: perPage,
      field: field,
      order: order,
    });
  };

  const applyDateFilter = (): void => {
    getWinners(
      filter.blocked,
      state.page,
      state.perPage,
      state.field,
      state.order,
      filter.endDate,
      filter.startDate,
      searchState[filter.searchField],
      filter.searchField,
    );
  };
  const clearDateFilter = (): void => {
    setFilter({
      ...filter,
      startDate: new Date("2000-01-18T19:55:00.000+00:00"),
      endDate: new Date("2030-01-18T19:55:00.000+00:00"),
    });
  };

  const setStartDate = (value: Date): void => {
    setFilter({ ...filter, startDate: value });
  };

  const setEndDate = (value: Date): void => {
    setFilter({ ...filter, endDate: value });
  };
  const filterDropdown = (title: string) => {
    const titleArray = title.toLowerCase().split(" ");
    setDropdown({ ...dropdown, [titleArray[0]]: !dropdown[titleArray[0]] });
  };
  const handleSort = (direction: string, title: string) => {
    let field = getFieldByTitle(title);
    if (field === "Finish date") {
      field = "drawDate";
    }
    getWinners(
      filter.blocked,
      state.page,
      state.perPage,
      field,
      direction,
      filter.endDate,
      filter.startDate,
      searchState[filter.searchField],
      filter.searchField,
    );
  };
  const handleSortTitle = (direction: string, title: string) => {
    const field = "name";
    getWinners(
      filter.blocked,
      state.page,
      state.perPage,
      field,
      direction,
      filter.endDate,
      filter.startDate,
      searchState[filter.searchField],
      filter.searchField,
    );
  };
  const search = (value: string, field: string) => {
    setSearchState({ ...searchState, [field]: value });
  };
  const applySearch = (field: string) => {
    setFilter({ ...filter, searchField: field });
    getWinners(
      filter.blocked,
      1,
      10,
      "_id",
      "asc",
      filter.endDate,
      filter.startDate,
      searchState[field],
      field,
    );
  };
  const clearSearch = (clear: string) => {
    setSearchState({ ...searchState, [clear]: "" });
  };
  const clearDiscountFilter = () => {
    setBlockedFilter({ with: false, without: false });
    setFilter({ ...filter, blocked: "all" });
  };

  const closeModal = () => {
    setModal({ ...modal, showModal: false, id: "" });
  };

  const openModal = (id: string) => {
    setModal({ ...modal, showModal: true, id: id });
  };

  const handleLastPage = () => {
    const page = Math.ceil(state.total / state.perPage);
    getWinners(
      filter.blocked,
      page,
      state.perPage,
      state.field,
      state.order,
      filter.endDate,
      filter.startDate,
      searchState[filter.searchField],
      filter.searchField,
    );
  };

  const handleFirstPage = () => {
    getWinners(
      filter.blocked,
      1,
      state.perPage,
      state.field,
      state.order,
      filter.endDate,
      filter.startDate,
      searchState[filter.searchField],
      filter.searchField,
    );
  };

  const handleChangeRowsPerPage = (
    event: React.ChangeEvent<HTMLInputElement>,
  ): void => {
    const perPage = parseInt(event.target.value, 10);
    getWinners(
      filter.blocked,
      1,
      perPage,
      state.field,
      state.order,
      filter.endDate,
      filter.startDate,
      searchState[filter.searchField],
      filter.searchField,
    );
  };

  const applyFilter = (field: string, conditions: Array<string>) => {
    getWinners(
      filter.blocked,
      state.page,
      state.perPage,
      state.field,
      state.order,
      filter.endDate,
      filter.startDate,
      conditions,
      field,
    );
  };

  const handleChangePage = (
    event: React.MouseEvent<HTMLButtonElement> | null,
    newPage: number,
  ): void => {
    getWinners(
      filter.blocked,
      newPage + 1,
      state.perPage,
      state.field,
      state.order,
      filter.endDate,
      filter.startDate,
      searchState[filter.searchField],
      filter.searchField,
    );
  };

  const removeWinner = async () => {
    try {
      const result = await dataProvider.delete("winners", {
        id: modal.id,
        previousData: {} as Winner,
      });
      if (result.data) {
        closeModal();
        notify(result.data.message, "info");
        getWinners(
          filter.blocked,
          state.page,
          state.perPage,
          state.field,
          state.order,
          filter.endDate,
          filter.startDate,
          searchState[filter.searchField],
          filter.searchField,
        );
      }
    } catch (error) {
      notify("Winner not found", "error");
    }
  };

  const closeFilter = () => {
    setDropdown({
      competitionNumber: false,
      competition: false,
      finish: false,
      title: false,
    });
  };

  const formatDate = (iso: string | number | Date) => {
    const d = new Date(iso);

    const day = String(d.getDate()).padStart(2, "0");
    const month = String(d.getMonth() + 1).padStart(2, "0");
    const year = d.getFullYear();

    return `${day}.${month}.${year}`;
  };

  return (
    <>
      <SettingsListTittle
        title="Winners"
        hideAddButton={false}
        isShow={checkPermission(permissions, "Winners", "Update")}
      />
      <Box marginTop="0.5em">
        <Card>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell id="active-table-head">
                    <HeadTable
                      title="Finish date"
                      sort={handleSort}
                      filterHandle={filterDropdown}
                    />
                    {dropdown.finish && (
                      <DateFilter
                        applyDateFilter={applyDateFilter}
                        clearDateFilter={clearDateFilter}
                        endDate={filter.endDate}
                        startDate={filter.startDate}
                        setStartDate={setStartDate}
                        setEndDate={setEndDate}
                      />
                    )}
                  </TableCell>
                  <TableCell id="active-table-head">
                    <HeadTable title="Title" sort={handleSortTitle} />
                    {dropdown.title && (
                      <TablesSearch
                        search={(event) =>
                          search(event.currentTarget.value, "title")
                        }
                        applySearch={() => applySearch("title")}
                        searchString={searchState.title}
                        clearSearch={() => clearSearch("title")}
                      />
                    )}
                  </TableCell>
                  <TableCell id="active-table-head">
                    <HeadTable title="Prize" />
                  </TableCell>
                  <TableCell id="active-table-head-actions">Actions</TableCell>
                </TableRow>
              </TableHead>
              {state.winners.map((item) => {
                return (
                  <TableBody
                    key={item.id}
                    className={item.id === modal.id ? "mark-user-row" : ""}
                    onClick={closeFilter}
                  >
                    <TableRow>
                      <TableCell>{formatDate(item.drawDate)}</TableCell>
                      <TableCell>{item.name}</TableCell>
                      <TableCell>{item.prizeTitle}</TableCell>
                      <TableCell>
                        <div className="actions-table-body">
                          {checkPermission(permissions, "Winners", "View") && (
                            <ShowButton to={`winners/${item.id}/show`} />
                          )}
                          {checkPermission(
                            permissions,
                            "Winners",
                            "Update",
                          ) && (
                            <EditButton
                              to={`winners/${item.id}`}
                              className="edit-prize"
                            />
                          )}
                          {checkPermission(
                            permissions,
                            "Winners",
                            "Delete",
                          ) && (
                            <div onClick={() => openModal("" + item.id!)}>
                              <DeleteForeverIcon className="delete-icon" />
                            </div>
                          )}
                        </div>
                      </TableCell>
                    </TableRow>
                  </TableBody>
                );
              })}
            </Table>
          </TableContainer>
          <PaginationTable
            page={state.page}
            perPage={state.perPage}
            collectionLength={state.winners.length}
            total={state.total}
            handleChangePage={handleChangePage}
            handleLastPage={handleLastPage}
            handleChangeRowsPerPage={handleChangeRowsPerPage}
            handleFirstPage={handleFirstPage}
            title="winners"
          />
          <Dialog fullWidth open={modal.showModal} onClose={closeModal}>
            <DialogContent>
              <RemoveEntityModalContent
                closeModal={closeModal}
                removeUser={removeWinner}
                entityName={"winner"}
              />
            </DialogContent>
          </Dialog>
        </Card>
      </Box>
    </>
  );
};

export default WinnersList;
